import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { AsyncPriceCourseCard } from '@udemy/browse-course/';
import { ShoppingClient } from '@udemy/shopping';
import styles from "./single-selectable-unit-container.module.css";
const CourseCardImageComponent = (ImageComponent, props) => /*#__PURE__*/React.createElement(ImageComponent, Object.assign({}, props, {
  className: classNames(props.className)
}));
const COURSE_CARD_PROPS = {
  priceProps: {
    showListPriceOnly: false,
    listPriceClassName: 'bundle-course-price'
  },
  renderCourseImage: CourseCardImageComponent,
  showDetails: false,
  size: 'large'
};
export const SingleSelectableUnitContainer = observer(({
  bundleUnitStore,
  buyable
}) => {
  var _bundleUnitStore$unit, _bundleUnitStore$unit2, _ShoppingClient$lists3, _ShoppingClient$lists4;
  const bundleItems = (_bundleUnitStore$unit = bundleUnitStore === null || bundleUnitStore === void 0 || (_bundleUnitStore$unit2 = bundleUnitStore.unit) === null || _bundleUnitStore$unit2 === void 0 ? void 0 : _bundleUnitStore$unit2.items) !== null && _bundleUnitStore$unit !== void 0 ? _bundleUnitStore$unit : [];
  // If no bundle items are present, render the default buyable course card.
  if (!bundleItems.length) {
    var _ShoppingClient$lists, _ShoppingClient$lists2;
    const buyableItem = (_ShoppingClient$lists = ShoppingClient === null || ShoppingClient === void 0 || (_ShoppingClient$lists2 = ShoppingClient.lists.cart.items.find(cartItem => cartItem.buyable.id === buyable.id)) === null || _ShoppingClient$lists2 === void 0 ? void 0 : _ShoppingClient$lists2.buyable) !== null && _ShoppingClient$lists !== void 0 ? _ShoppingClient$lists : buyable;
    return /*#__PURE__*/React.createElement("div", {
      className: styles['single-selectable-unit-container']
    }, /*#__PURE__*/React.createElement(AsyncPriceCourseCard, Object.assign({}, COURSE_CARD_PROPS, {
      course: buyableItem,
      key: buyableItem.id
    })));
  }
  const cartItems = (_ShoppingClient$lists3 = ShoppingClient === null || ShoppingClient === void 0 || (_ShoppingClient$lists4 = ShoppingClient.lists.cart.items) === null || _ShoppingClient$lists4 === void 0 ? void 0 : _ShoppingClient$lists4.map(cartItem => cartItem.buyable)) !== null && _ShoppingClient$lists3 !== void 0 ? _ShoppingClient$lists3 : [];
  const buyableItemIds = new Set([buyable, ...bundleItems].map(buyableItem => buyableItem.id));
  const orderedMap = new Map([[buyable.id, 0]]);
  bundleItems.forEach((item, index) => orderedMap.set(item.id, index + 1));

  // Sort cart items to match bundle order, overriding /cart's response default LIFO order.
  const filteredCartItems = cartItems.filter(cartItem => buyableItemIds.has(cartItem.id)).sort((a, b) => {
    var _orderedMap$get, _orderedMap$get2;
    return ((_orderedMap$get = orderedMap.get(a.id)) !== null && _orderedMap$get !== void 0 ? _orderedMap$get : 0) - ((_orderedMap$get2 = orderedMap.get(b.id)) !== null && _orderedMap$get2 !== void 0 ? _orderedMap$get2 : 0);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles['single-selectable-unit-container']
  }, filteredCartItems.map(course => /*#__PURE__*/React.createElement(AsyncPriceCourseCard, Object.assign({}, COURSE_CARD_PROPS, {
    course: course,
    key: course.id
  }))));
});
//# sourceMappingURL=single-selectable-unit-container.react-component.js.map